import React from 'react';
import { ShieldAlert, Lock, FileCheck, AlertTriangle } from 'lucide-react';
import { PageWrapper, SectionWrapper } from '../components/MotionWrappers';
export function SecurityDisclaimer() {
  return <PageWrapper data-id="element-693">
      <div className="bg-white min-h-screen" data-id="element-694">
        <div className="bg-federal-blue py-16 text-white" data-id="element-695">
          <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-696">
            <h1 className="text-4xl font-black mb-4" data-id="element-697">Security Disclaimer</h1>
            <p className="text-white/70" data-id="element-698">
              Compliance & Risk Management Framework
            </p>
          </div>
        </div>

        <div className="max-w-4xl mx-auto px-4 md:px-8 py-16" data-id="element-699">
          <div className="grid gap-12" data-id="element-700">
            <SectionWrapper data-id="element-701">
              <section className="bg-slate-50 p-8 border-l-4 border-muted-gold rounded-sm" data-id="element-702">
                <div className="flex items-center gap-3 mb-4" data-id="element-703">
                  <ShieldAlert className="w-6 h-6 text-federal-blue" data-id="element-704" />
                  <h2 className="text-xl font-bold text-federal-blue" data-id="element-705">
                    NIST Compliance Statement
                  </h2>
                </div>
                <p className="text-tech-slate leading-relaxed" data-id="element-706">
                  Codes & Cogs LLC operates under a strict adherence to NIST
                  Special Publication 800-171 and 800-53. While we implement
                  rigorous security controls for our Comply+ platform and
                  infrastructure services, the ultimate responsibility for
                  agency-side implementation and Authority to Operate (ATO)
                  remains with the client agency.
                </p>
              </section>
            </SectionWrapper>

            <SectionWrapper delay={0.05} data-id="element-707">
              <section data-id="element-708">
                <h2 className="text-2xl font-bold text-federal-blue mb-6" data-id="element-709">
                  Digital Accessibility Remediation
                </h2>
                <p className="text-tech-slate leading-relaxed mb-4" data-id="element-710">
                  Our Comply+ platform utilizes autonomous scanning to identify
                  and remediate WCAG 2.1 Level AA gaps. However:
                </p>
                <ul className="space-y-4" data-id="element-711">
                  <li className="flex items-start gap-3" data-id="element-712">
                    <AlertTriangle className="w-5 h-5 text-muted-gold mt-1 flex-shrink-0" data-id="element-713" />
                    <span className="text-tech-slate" data-id="element-714">
                      Automated remediation is a tool to assist in compliance;
                      it does not replace the need for regular manual
                      accessibility audits by qualified professionals.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-715">
                    <AlertTriangle className="w-5 h-5 text-muted-gold mt-1 flex-shrink-0" data-id="element-716" />
                    <span className="text-tech-slate" data-id="element-717">
                      Codes & Cogs does not guarantee 100% legal immunity from
                      DOJ Title II mandates through the use of automated tools
                      alone.
                    </span>
                  </li>
                </ul>
              </section>
            </SectionWrapper>

            <SectionWrapper delay={0.1} data-id="element-718">
              <section className="border-t border-slate-200 pt-12" data-id="element-719">
                <h2 className="text-2xl font-bold text-federal-blue mb-6" data-id="element-720">
                  Infrastructure & Data Integrity
                </h2>
                <div className="grid md:grid-cols-2 gap-8" data-id="element-721">
                  <div className="space-y-4" data-id="element-722">
                    <div className="flex items-center gap-2" data-id="element-723">
                      <Lock className="w-5 h-5 text-federal-blue" data-id="element-724" />
                      <h3 className="font-bold text-federal-blue" data-id="element-725">
                        Encryption
                      </h3>
                    </div>
                    <p className="text-sm text-tech-slate" data-id="element-726">
                      All data is encrypted at rest and in transit using FIPS
                      140-2 validated cryptographic modules.
                    </p>
                  </div>
                  <div className="space-y-4" data-id="element-727">
                    <div className="flex items-center gap-2" data-id="element-728">
                      <FileCheck className="w-5 h-5 text-federal-blue" data-id="element-729" />
                      <h3 className="font-bold text-federal-blue" data-id="element-730">
                        Audit Logs
                      </h3>
                    </div>
                    <p className="text-sm text-tech-slate" data-id="element-731">
                      Comprehensive audit logging is maintained for all system
                      access and remediation actions to support forensic
                      investigations.
                    </p>
                  </div>
                </div>
              </section>
            </SectionWrapper>

            <SectionWrapper delay={0.1} data-id="element-732">
              <section className="bg-federal-blue text-white p-8 rounded-sm" data-id="element-733">
                <h2 className="text-xl font-bold mb-4" data-id="element-734">Security Reporting</h2>
                <p className="text-white/80 mb-6" data-id="element-735">
                  If you believe you have discovered a security vulnerability in
                  any Codes & Cogs system, please report it immediately through
                  our secure disclosure channel.
                </p>
                <button className="bg-muted-gold hover:bg-gold-hover text-white px-6 py-3 font-bold rounded-sm transition-colors" data-id="element-736">
                  Submit Security Report
                </button>
              </section>
            </SectionWrapper>
          </div>
        </div>
      </div>
    </PageWrapper>;
}